import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";

@Component({
    selector: 'app-info-modal',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
})
export class InfoComponentModal implements OnInit {

    public type: string = '';
    public text: string = '';

    constructor(private modalCtrl: ModalController,
                private navParams: NavParams,) {
    }

    ngOnInit() {
        this.type = this.navParams.data['type'] ?? '';

        this.text = this.navParams.data['text']?? '';
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }



}
